import { Badge } from '@repo/ui/components/ui/badge'
import { Calendar, Clock } from 'lucide-react'
import type { BlogPost } from '@/features/blog/data'

interface PostHeaderProps {
  post: BlogPost
}

export function PostHeader({ post }: PostHeaderProps) {
  return (
    <header className="mb-12">
      <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">{post.title}</h1>

      <div className="flex items-center gap-6 text-sm text-muted-foreground mb-6">
        <div className="flex items-center gap-2">
          <Calendar className="w-4 h-4" />
          <time dateTime={post.date}>
            {new Date(post.date).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
          </time>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4" />
          <span>{post.readTime}</span>
        </div>
      </div>

      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <span className="text-sm font-semibold text-primary">{post.author.name.charAt(0)}</span>
        </div>
        <div>
          <div className="font-medium">{post.author.name}</div>
        </div>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        {post.tags.map((tag) => (
          <Badge key={tag} variant="default">
            {tag}
          </Badge>
        ))}
      </div>
    </header>
  )
}
